/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AccountCreationModalAliases {
  FRAGMENT_0 = 'fragment-0',
  FRAGMENT_1 = 'fragment-1',
  FRAGMENT_COMPLETED = 'fragment-completed',
  FRAGMENT_FORMS = 'fragment-forms',
  FRAGMENT_PROCESSING = 'fragment-processing',
  LAYOUT_BASE = 'layout-base',
  LAYOUT_ROUTE_FORMULARY_ACCOUNT_CREATION_MODAL = 'layout-route-formulary-account-creation-modal',
  MODAL_ACCOUNT_CREATION = 'modal-account-creation',
  ROUTE_0 = 'route-0',
  ROUTE_1 = 'route-1',
  ROUTE_COMPLETED = 'route-completed',
  ROUTE_FORMS = 'route-forms',
  ROUTE_PROCESSING = 'route-processing',
}
export { AccountCreationModalAliases };
